import fetchData from "@/lib/fetchData";

import { GET_CURRENT_LPO } from "@/lib/rootApi";

export default {
  namespaced: true,

  state: {
    lpo: null,
    lpoLoading: false,
  },

  mutations: {
    setCurrentLpo(state, lpo) {
      state.lpo = lpo;
    },
    setCurrentLpoLoading(state, loading) {
      state.lpoLoading = loading;
    },
  },

  actions: {
    getCurrentLpo(context, lpo_id) {
      const { commit } = context;

      const form = new FormData();
      form.append("lpo_id", lpo_id);

      commit("setCurrentLpoLoading", true);

      return fetchData(GET_CURRENT_LPO, form)
        .then((lpo) => {
          commit("setCurrentLpo", lpo);
        })
        .finally(() => {
          commit("setCurrentLpoLoading", false);
        });
    },
  },
};
